export const FEATURE_FLAGS: Record<string, string> = {
    NURSERY_PROTOTYPE: 'nursery_checklist_prototype',
    COLLAPSED_BUTTON: 'collapsed_button',
};
